import Modal from './modal'

export {Modal}

export default Modal
